"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpPrefix = void 0;
/**
 * meeting.tencent.com后台服务对应的路径配置
 */
var HttpPrefix;
(function (HttpPrefix) {
    HttpPrefix["WEMEET_WEB_API"] = "/wemeet-webapi";
    HttpPrefix["WEMEET_WEB_API_TEST"] = "/wemeet-webapi-test";
    HttpPrefix["WEMEET_WEB_API_PRE"] = "/wemeet-webapi-pre-release";
    HttpPrefix["WEMEET_TAPI"] = "/wemeet-tapi";
    HttpPrefix["NEXT_API"] = "/v2/api";
    HttpPrefix["WEMEET_CLOUDRECORDING_API"] = "/wemeet-cloudrecording-webapi";
    HttpPrefix["WEB_SERVICE"] = "/web-service";
})(HttpPrefix = exports.HttpPrefix || (exports.HttpPrefix = {}));
//# sourceMappingURL=http.js.map